import { Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import { formatCurrencyInCents } from '../../helpers/formatters';

export default function ReplacementPartsOverviewCards({ stats }) {
    const {
        total_items: totalItems = 0,
        total_stock_value_cents: totalStockValueCents = 0,
    } = stats || {};

    return (
        <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Total de itens
                        </Typography>
                        <Typography variant="subtitle1" fontWeight={700}>
                            {totalItems}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="caption" color="text.secondary" display="block">
                            Total em reais
                        </Typography>
                        <Typography variant="subtitle1" fontWeight={700}>
                            {formatCurrencyInCents(totalStockValueCents)}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
